<template>
  <div class="wrapper">
    <div class="top_contain">
      <img class="tanhao_inage" src="../../../../../assets/img/tanhao.png" alt="" />
      <div class="font_14_1890FF">
        <span class="font_14_333333">请配置当前角色在系统管理中的菜单访问权限。</span
        >如果需要进行二次授权时，可选择的权限范围为此处配置的应用菜单权限。
      </div>
    </div>
    <el-tree
      ref="tree"
      class="margin_top_10"
      style="width:100%"
      :data="Data"
      node-key="id"
      show-checkbox
      default-expand-all
      @check="checkChangeMenthod"
      :default-checked-keys="selectedKeyArray"
    >
      <div class="flex_row_center_start" slot-scope="{ data }">
        <span>{{ data.name }}</span>
      </div>
    </el-tree>
  </div>
</template>

<script>
import Axios from '@/lib/axios';
import API from '@/lib/apiList';
import NewAxios from '@/lib/newEnvironmentAxios';
export default {
  props: {
    roleId: String
  },
  data() {
    return {
      selectedKeyArray: [],
      Data: []
    };
  },
  watch: {
    roleId(value) {
      if (value.length > 0) {
        this.allResourceRequest();
      }
    }
  },
  mounted() {
    this.allResourceRequest();
  },
  methods: {
    checkChangeMenthod(e) {
      let res = this.$refs.tree.getCheckedKeys();
      this.$emit('applicationAuthorPCMenthod', {
        value: res
      });
    },

    /** 处理所有的资源列表 */
    dealAllResourceData(array) {
      let totalArray = [];
      let userInfoDict = {};
      let userInfoChildren = [];
      let machineInfoDict = {};
      let machineInfoChildren = [];
      let anotherInfoDict = {};
      let anotherInfoChildren = [];
      let anotherInfoDict1 = {};
      let anotherInfoChildren1 = [];
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.sysMark == '0') {
          if (element.sysCode == 'SMHT') {
            if (element.code == '1010') {
              userInfoDict = element;
            }
            if (element.code == '1011') {
              machineInfoDict = element;
            }
            if (element.code == '1012') {
              anotherInfoDict = element;
            }
            if (element.code == '1013') {
              anotherInfoDict1 = element;
            }
            // if (element.code == '1012') {
            //   anotherInfoDict = element;
            // }
          }
        }
      }
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.sysMark == '0') {
          if (element.sysCode == 'SMHT') {
            if (element.parentCode == '1010') {
              userInfoChildren.push(element);
            }
            if (element.parentCode == '1011') {
              machineInfoChildren.push(element);
            }
            if (element.parentCode == '1012') {
              anotherInfoChildren.push(element);
            }
            if (element.parentCode == '1013') {
              anotherInfoChildren1.push(element);
            }
            // if (element.parentCode == '1012') {
            //   anotherInfoChildren.push(element);
            // }
          }
        }
      }
      userInfoDict.children = userInfoChildren;
      machineInfoDict.children = machineInfoChildren;
      anotherInfoDict.children = anotherInfoChildren;
      anotherInfoDict1.children = anotherInfoChildren1;

      totalArray = [userInfoDict, machineInfoDict, anotherInfoDict, anotherInfoDict1];
      this.Data = totalArray;
    },

    /** 处理(指定role的角色) 返回的资源数据 */
    dealWithResourceData(toatalArray, anotherArray) {
      this.selectedKeyArray = [];
      for (let index = 0; index < toatalArray.length; index++) {
        const element = toatalArray[index];
        for (let index = 0; index < anotherArray.length; index++) {
          const anotherelement = anotherArray[index];
          if (element.code == anotherelement) {
            this.selectedKeyArray.push(element.id);
          }
        }
      }
      // this.checkChangeMenthod();
      this.$emit('applicationAuthorPCMenthod', {
        value: this.selectedKeyArray
      });
    },

    /** =================================  ⬇ 网络请求相关 ⬇ ============================================ */
    /** 获取所有的资源列表 */
    allResourceRequest() {
      NewAxios.requestWWWForm({
        data: {
          ...API.searchResourcesPage,
          requestData: {
            projectId: this.$cookies.get('PROJECT_ID'),
            pageNo: 1,
            pageSize: 10000
          }
        }
      })
        .then(res => {
          if (res.data.resultStatus === 1000) {
            let paragram = JSON.parse(res.data.result).result;
            let data = paragram.result;
            this.dealAllResourceData(data);
            this.roleResouseRequest(data);
          } else {
            this.$message.error(res.data.memo);
          }
        })
        .catch(err => {
          // this.$message.error(err.message);
        });
    },

    /** 根据roleid获取菜单权限数组 */
    roleResouseRequest(totalArray) {
      NewAxios.requestWWWForm({
        data: {
          ...API.getRoloMenuAndSysTem,
          requestData: {
            projectId: this.$cookies.get('PROJECT_ID'),
            roleId: this.roleId
          }
        }
      })
        .then(res => {
          if (res.data.resultStatus === 1000) {
            let paragram = JSON.parse(res.data.result);
            this.dealWithResourceData(totalArray, paragram.smhtFront);
          } else {
            this.$message.error(res.data.memo);
          }
        })
        .catch(err => {
          // this.$message.error(err.message);
        });
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.top_contain {
  background: #eef7fe;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #d5ebfd;
  margin-bottom: 19px;
  width: 100%;
}

.tanhao_inage {
  width: 18px;
  height: 18px;
}

.font_14_333333 {
  font-size: 14px;
  color: #333333;
}

.font_14_1890FF {
  font-size: 14px;
  color: #1890ff;
}
</style>
